import Vue, { CreateElement, VNode } from 'vue';

export default Vue.component('cntrl-btn', {
  functional: true,
  render(createElement: CreateElement, { props, listeners}): VNode {
    return createElement('button', {
      on: { click: () => (listeners as any).click() },
      domProps: {
        disabled: (props as any).disabled,
        innerHTML: (props as any).icon,
      },
      class: [
        'control-bttns',
        !!(props as any).left && 'left',
      ],
      style: [
        !!(props as any).calibrateMargin
          && (props as any).left
            ? { left: `${(props as any).calibrateMargin}px` }
            : { right: `${(props as any).calibrateMargin}px` },
      ],
    });
  },
});
